import {Component, Input, OnInit} from '@angular/core';
import {AgentReservationService} from '../shared/api/resources/agent-reservation/agent-reservation.service';
import {Booking} from '../shared/api/model/booking';
import {BookingDetailsComponent} from '../shared/atoms/booking-details/booking-details.component';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() userLoaded: boolean;
  @Input() settingsLoaded: boolean;
  searchingTicket = false;
  searchTimeout = setTimeout(() => {}, 0);
  modalRef: NgbModalRef;

  constructor(
    private _agentReservationService: AgentReservationService,
    private _modalService: NgbModal) { }

  ngOnInit() {
  }

  searchTicket(ticket: string) {
    this.searchingTicket = true;
    clearTimeout(this.searchTimeout);
    if (ticket && ticket.length >= 3) {
      this.searchTimeout = setTimeout(() => {
        this._agentReservationService.findBooking(ticket).subscribe(
          (bookings: Booking[]) => {
            let booking: Booking;
            if (bookings instanceof Array) {
              if (bookings.length > 0) {
                booking = bookings[0];
              }
            } else {
              booking = bookings;
            }

            this.modalRef = this._modalService.open(BookingDetailsComponent, {size: 'lg'});
            this.modalRef.componentInstance.bookingId = booking.id;
            this.modalRef.componentInstance.supplierId = booking.event.supplierId;
          },
          undefined,
          () => this.searchingTicket = false
        );
      }, 1000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts